import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ParticipationStatusPopup.css';

const ParticipationStatusPopup = ({ isOpen, onClose, vehicleId, sessionNumber, initialTab = 'COMPLETE' }) => {
  const [loading, setLoading] = useState(true);
  const [participationData, setParticipationData] = useState(null);
  const [activeTab, setActiveTab] = useState(initialTab);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (isOpen && vehicleId && sessionNumber) {
      fetchParticipationData();
    }
  }, [isOpen, vehicleId, sessionNumber]);

  // Set active tab when initialTab changes
  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  const fetchParticipationData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`http://eframeehs.in:3001/api/user-assessment-participation?vehicleId=${vehicleId}&sessionNumber=${sessionNumber}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch participation data');
      }
      
      const data = await response.json();
      setParticipationData(data);
      setErrorMessage('');
    } catch (error) {
      console.error('Error fetching participation data:', error);
      setErrorMessage('Failed to load participation data. Please try again.');
      setParticipationData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (status) => {
    setActiveTab(status);
  };

  const renderUserList = () => {
    if (!participationData || !participationData.users) {
      return <p>No data available</p>;
    }

    const filteredUsers = participationData.users.filter(user => user.Status === activeTab);

    if (filteredUsers.length === 0) {
      return <p className="no-users-message">No users in this category</p>;
    }

    return (
      <div className="user-list">
        <table>
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Vehicle Name</th>
              <th>Session Number</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={`${user.userPK}-${index}`}>
                <td>{user.EmployeeName}</td>
                <td>{user.ScreenName}</td>
                <td>{user.AttemptNumber}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  if (!isOpen) return null;

  // Create popup content
  const popupContent = (
    <div className="participation-popup-overlay">
      <div className="participation-popup">
        <div className="participation-popup-header">
          <h2>Session {sessionNumber} Participation</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {errorMessage && (
          <div className="error-message">{errorMessage}</div>
        )}

        {loading ? (
          <div className="loading-spinner">
            <div>Loading participation data...</div>
          </div>
        ) : (
          <>
            <div className="tabs-container">
              <div className="tabs">
                <button 
                  className={`tab ${activeTab === 'COMPLETE' ? 'active' : ''}`}
                  onClick={() => handleTabChange('COMPLETE')}
                >
                  <span className="count">{participationData?.summary?.completed || 0}</span>
                  <span>No. of Users Assessment Completed</span>
                </button>
                <button 
                  className={`tab ${activeTab === 'INCOMPLETE' ? 'active' : ''}`}
                  onClick={() => handleTabChange('INCOMPLETE')}
                >
                  <span className="count">{participationData?.summary?.incomplete || 0}</span>
                  <span>No. of Users Assessment Ongoing</span>
                </button>
                <button 
                  className={`tab ${activeTab === 'NOT STARTED' ? 'active' : ''}`}
                  onClick={() => handleTabChange('NOT STARTED')}
                >
                  <span className="count">{participationData?.summary?.notStarted || 0}</span>
                  <span>No. of Users Assessment Not Attempted</span>
                </button>
              </div>
            </div>

            <div className="tab-content">
              {renderUserList()}
            </div>
          </>
        )}
      </div>
    </div>
  );

  // Use React Portal to render the popup directly to the body
  return ReactDOM.createPortal(
    popupContent,
    document.body
  );
};

export default ParticipationStatusPopup; 